import { renderPrefilledField } from '@containers/form-i9/document-details-list/field-content';
import {
    DocumentDetailLabel,
    DocumentDetailLabelGridItem
} from '@containers/form-i9/document-details-list/styles';
import { Grid } from '@material-ui/core';
import { ISection2DocumentDetails } from '@models/onboarding-review/section2-document-details';
import { ISection2DocumentTypesValidation } from '@stores/onboarding-review/section2-document-types-validation-store';
import {
    identity,
    isNil
} from 'lodash';
import { observer } from 'mobx-react';
import * as React from 'react';

interface IProps<Detail extends keyof ISection2DocumentDetails> {
    details?: ISection2DocumentDetails;
    fieldName: Detail;
    transformValue?: (value: ISection2DocumentDetails[Detail], documentTypesValidation?: ISection2DocumentTypesValidation[] ) => any;
    label?: string;
    placeholder: string;
    documentTypesValidation?: ISection2DocumentTypesValidation[];
    renderFieldContent?: (
        fieldText: string,
        placeholder: string,
        value?: ISection2DocumentDetails[Detail]
    ) => React.ReactNode | React.ReactNode[];
}

class DocumentDetailField<Detail extends keyof ISection2DocumentDetails> extends React.Component<IProps<Detail>> {
    render() {
        const {
            details,
            fieldName,
            placeholder,
            transformValue = identity,
            label,
            renderFieldContent = renderPrefilledField,
            documentTypesValidation
        } = this.props;

        const value = details?.[fieldName];
        const hasValue = !isNil(value);

        const getFieldText = () => {
            const potentialValue = details?.[fieldName];
            if (isNil(potentialValue)) {
                return placeholder;
            }

            return transformValue(potentialValue, documentTypesValidation);
        };

        return (
            <Grid container={true}
                  direction='row'
                  wrap='nowrap'>
                {
                    label && (
                        <DocumentDetailLabelGridItem xs={4}>
                            <DocumentDetailLabel>{label}</DocumentDetailLabel>
                        </DocumentDetailLabelGridItem>
                    )
                }
                <Grid item={true}
                      container={true}
                      xs={true}
                      direction='column'
                      zeroMinWidth={true}>
                    {
                        renderFieldContent(
                            getFieldText(),
                            placeholder,
                            hasValue ? transformValue(value!) : value
                        )
                    }
                </Grid>
            </Grid>
        );
    }
}

export default observer(DocumentDetailField);



// WEBPACK FOOTER //
// ./src/containers/form-i9/document-details-list/detail-field.tsx